export default __webpack_public_path__ + "0956475c35edae51e149d927115618c0.jpg";